import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { headerIconButtonClass } from "./headerButton";
import { HeaderTip } from "./HeaderTip";

export const SettingsButton = ({ onClick, selected = false }: { onClick: () => void; selected?: boolean }) => (
  <HeaderTip label="Settings">
    <button
      type="button"
      onClick={onClick}
      data-selected={selected ? "true" : undefined}
      aria-label="Settings"
      aria-haspopup="dialog"
      data-testid="maintenance-submenu-button"
      className={headerIconButtonClass}
    >
      <FontAwesomeIcon icon={faGear} size="lg" />
    </button>
  </HeaderTip>
);
